import { __assign } from "tslib";
import React from 'react';
import { ConfigProvider } from '../wrappers/config';
import { ClientProvider as DataSourceClientProvider, } from '../wrappers/graphql';
import { DataStoreProvider } from '../wrappers/providers';
import { RouteProvider } from '../wrappers/router';
var convertCamelCase = function (text, glue) {
    if (text === void 0) { text = ''; }
    return text.replace(/[A-Z]/g, function (letter, index) {
        var loweredLetter = letter.toLowerCase();
        return index === 0 ? loweredLetter : "".concat(glue).concat(loweredLetter);
    });
};
var HYDRATE_ID_PREFIX = 'ravejs-component';
export var withProviders = function (Component, _a) {
    var routeInfo = _a.routeInfo, dataSourceConfigs = _a.dataSourceConfigs, clientConfig = _a.clientConfig, hydrateId = _a.hydrateId;
    var componentHydrateId = "".concat(HYDRATE_ID_PREFIX, "-").concat(convertCamelCase(hydrateId || 'unnamed', '-'));
    var Wrapper = function (_a) {
        var data = _a.data, ctx = _a.ctx;
        return (React.createElement("div", { id: "ravejs-exported-component" },
            React.createElement(DataSourceClientProvider, __assign({}, dataSourceConfigs),
                React.createElement(ConfigProvider, { config: {
                        client: clientConfig,
                    } },
                    React.createElement(RouteProvider, { ctx: ctx, routeInfo: routeInfo, useNativeMethods: true },
                        React.createElement(DataStoreProvider, null,
                            React.createElement(Component, { data: data })))))));
    };
    Wrapper.displayName = hydrateId;
    Wrapper.hydrateId = componentHydrateId;
    Wrapper.storeId = "__".concat(convertCamelCase(hydrateId, '_').toUpperCase(), "__INITIAL__DATA__");
    return Wrapper;
};
export default withProviders;
//# sourceMappingURL=with-providers.js.map